import React, { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

// Components
import CompanyappHome from "../screens/home/companyapp/home";

import SSOAuth from "../screens/auth/ssoauth";
import Login from "../screens/auth/login";
import AuthCallback from "../screens/auth/authCallback";
import Oauth from "../screens/auth//oauth";
import OAuthCallback from "../screens/auth/oauthCallback";

import Profile from "../screens/account/profile";
import Notifications from "../screens/account/notification";
import AddPresentation from "../screens/presentations/addPresentation";
import EditPresentation from "../screens/presentations/editPresentation";
import PresentationsCreator from "../screens/presentations/presentationsCreator";
import Presentations from "../screens/presentations/presentationsIndex";
import ViewPresentation from "../screens/presentations/viewPresentation";
import AddIn from "../screens/account/addIn";
import LaptopApp from "../screens/account/laptopApp";
import Training from "../screens/account/training";
import PushNotifications from "../screens/account/pushNotifications";
import CompanyappTags from "../screens/account/companyappTags";
import RHGMap from "../screens/rhgMap/index";
import HotelProfile from "../screens/rhgHotel/hotelProfile";
import { isCompanyappUser } from "../utils/helpers";

//
import News from "../screens/news/news";
import NewsSingle from "../screens/news/newsSingle";
import NewsNode from "../screens/news/newsNode";
import NewsSingleNode from "../screens/news/newsSingleNode";
import DocumentsNode from "../screens/documents/documentsNode";
import DocumentSingleNode from "../screens/documents/documentSingleNode";
import EventsNode from "../screens/events/eventsNode";
import EventSingleNode from "../screens/events/eventSingleNode";
import LinksNode from "../screens/links/linksNode";
import PodcastsNode from "../screens/podcasts/podcastsNode";
import PodcastSingleNode from "../screens/podcasts/podcastSingleNode";
import VideosNode from "../screens/videos/videosNode";
import VideoSingleNode from "../screens/videos/videoSingleNode";
import NewsCreator from "../screens/news/newsCreator";
import AddNews from "../screens/news/addNews";
import NewsEdit from "../screens/news/newsEdit";
import Documents from "../screens/documents/documents";
import DocumentsCreator from "../screens/documents/documentsCreator";
import AddDocument from "../screens/documents/addDocument";
import DocumentEdit from "../screens/documents/documentEdit";
import DocumentSingle from "../screens/documents//documentSingle";
import Videos from "../screens/videos/videos";
import VideosCreator from "../screens/videos/videosCreator";
import VideosSingle from "../screens/videos/videoSingle";
import VideoEdit from "../screens/videos/videoEdit";
import AddVideo from "../screens/videos/addVideo";
import Polls from "../screens/polls/polls";
import PollsCreator from "../screens/polls/pollsCreator";
import PollSingle from "../screens/polls/pollSingle";
import PollEdit from "../screens/polls/pollEdit";
import AddPoll from "../screens/polls/addPoll";
import Links from "../screens/links/links";
import LinksCreator from "../screens/links/linksCreator";
import LinkEdit from "../screens/links/linkEdit";
import AddLink from "../screens/links/addLink";
import Forms from "../screens/forms/forms";
import FormsCreator from "../screens/forms/formsCreator";
import FormSingle from "../screens/forms/formSingle";
import FormEdit from "../screens/forms/formEdit";
import AddForm from "../screens/forms/addForm";
import Podcasts from "../screens/podcasts/podcasts";
import PodcastsCreator from "../screens/podcasts/podcastsCreator";
import PodcastSingle from "../screens/podcasts/podcastSingle";
import PodcastEdit from "../screens/podcasts/podcastEdit";
import AddPodcast from "../screens/podcasts/addPodcasts";
import Quizzes from "../screens/quizzes/quizzes";
import QuizzesCreator from "../screens/quizzes/quizzesCreator";
import AddQuiz from "../screens/quizzes/addQuiz";
import QuizEdit from "../screens/quizzes/quizEdit";
import QuizSingle from "../screens/quizzes/quizSingle";
import Events from "../screens/events/events";
import EventSingle from "../screens/events/eventSingle";
import EventEdit from "../screens/events/eventEdit";
import EventsCreator from "../screens/events/eventsCreator";
import AddEvent from "../screens/events/addEvent";
import Blogs from "../screens/blogs/blogs";
import BlogSingle from "../screens/blogs/blogSingle";
import ForumsBoard from "../screens/forums/forumsBoard";
import ForumTopicList from "../screens/forums/forumTopicList";
import ForumTopicSingle from "../screens/forums/forumTopicSingle";
import Galleries from "../screens/galleries/galleries";
import GallerySingle from "../screens/galleries/gallerySingle";
import GalleriesCreator from "../screens/galleries/galleriesCreator";
import GalleryEdit from "../screens/galleries/galleryEdit";
import AddGallery from "../screens/galleries/addGallery";
import Contacts from "../screens/contacts/contacts";
import ContactSingle from "../screens/contacts/contactSingle";
import CompanyDirectory from "../screens/company_directory/companyDirectory";
import CompanyDirectoryCreator from "../screens/company_directory/companyDirectoryCreator";
import CompanyDirectorySingle from "../screens/company_directory/companyDirectorySingle";
import CompanyDirectoryEdit from "../screens/company_directory/companyDirectoryEdit";
import AddCompanyDirectory from "../screens/company_directory/addCompanyDirectory";
import CourseTraining from "../screens/training/training";
import CourseTrainingSingle from "../screens/training/trainingSingle";
import CourseTrainingNode from "../screens/training/trainingNode";
import CourseTrainingSingleNode from "../screens/training/trainingSingleNode";
import TrainingCreator from "../screens/training/trainingCreator";
import AddTraining from "../screens/training/addTraining";
import TrainingEdit from "../screens/training/trainingEdit";
import SearchScreen from "../screens/search/search";
import Bookmarks from "../screens/bookmarks/bookmarks";
import SalesRooms from "../screens/salesRooms/salesRooms";
import AddSalesRoom from "../screens/salesRooms/addSalesRoom";
import SalesRoomEdit from "../screens/salesRooms/salesRoomEdit";
import SalesRoomDetail from "../screens/salesRooms/salesRoomDetail";
import BuyerRoom from "../screens/room/buyerRoom";
import Fiori from "../screens/fiori/index";
import Contribute from "../partials/equans/contribute";
import ContributeCA from "../screens/contribute/contribute";
import Taxonomies from "../screens/taxonomies/taxonomies";
import TermSingle from "../screens/taxonomies/termSingle";

// App
import {
  client,
  permissionsEnabled,
  salesRoomsEnabled,
  tagsEnabled,
} from "../config";
import { logScreenView } from "../core/analytics";
import TaxonomySingle from "../screens/taxonomies/taxonomySingle";

// ---------------------------------------------------------------------------
// Creator mode
//
// The Redux `creatorMode` flag (toggled by the header switch) is the single
// source of truth. Each section has ONE route (/documents, /news, ...) and
// ModeRoute decides whether to render the normal list or the creator list.
// The old "-creator" URLs are kept only as redirects so bookmarks still work.
// ---------------------------------------------------------------------------

// segment -> [normal list screen, creator list screen]
const MODE_SCREENS = {
  presentations: [Presentations, PresentationsCreator],
  news: [News, NewsCreator],
  documents: [Documents, DocumentsCreator],
  videos: [Videos, VideosCreator],
  polls: [Polls, PollsCreator],
  links: [Links, LinksCreator],
  forms: [Forms, FormsCreator],
  podcasts: [Podcasts, PodcastsCreator],
  quizzes: [Quizzes, QuizzesCreator],
  events: [Events, EventsCreator],
  galleries: [Galleries, GalleriesCreator],
  training: [CourseTraining, TrainingCreator],
  company_directory: [CompanyDirectory, CompanyDirectoryCreator],
};

const PRESENTATIONS_ONLY = ["presentations"];
const COMPANYAPP_MODE_SEGMENTS = Object.keys(MODE_SCREENS);

// Effective creator mode = the global flag AND (where applicable) permission.
// radisson / revo-h already gate creator mode on this permission. Other
// clients rely on the header switch only being shown to eligible users;
// add a permission check here if they need one too.
const useCreatorMode = () => {
  const enabled = useSelector((state) => state.creatorModeReducer.creatorMode);
  const permissions = useSelector(
    (state) => state.permissionsReducer.permissions,
  );

  if (!enabled) return false;
  if (client === "radisson" || client === "revo-h") {
    return permissions?.access_presentation_creator_mode === true;
  }
  return true;
};

const ModeRoute = ({ view, creator }) => {
  const creatorMode = useCreatorMode();
  return creatorMode ? creator : view;
};

// Old "/<section>-creator" URLs: turn creator mode on, then go to the plain URL.
const LegacyCreatorRedirect = ({ to }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: "SET_CREATOR_MODE", payload: true });
  }, [dispatch]);
  return <Navigate to={to} replace />;
};

// Builds the mode-aware list route + legacy redirect for each segment.
const modeRoutes = (segments) =>
  segments.flatMap((seg) => {
    const [View, Creator] = MODE_SCREENS[seg];
    return [
      <Route
        key={seg}
        path={`/${seg}`}
        element={<ModeRoute view={<View />} creator={<Creator />} />}
      />,
      <Route
        key={`${seg}-creator`}
        path={`/${seg}-creator`}
        element={<LegacyCreatorRedirect to={`/${seg}`} />}
      />,
    ];
  });

// Route data
const screenViews = [
  { screenName: "Home", screenClass: "Home", title: "Home", path: "/" },
  {
    screenName: "Account",
    screenClass: "Profile",
    title: "Account",
    path: "/account",
  },
  {
    screenName: "Notifications",
    screenClass: "Notifications",
    title: "Notifications",
    path: "/account/notifications",
  },
  {
    screenName: "Add-In",
    screenClass: "AddIn",
    title: "Add-In",
    path: "/account/add-in",
  },
  {
    screenName: "Laptop App",
    screenClass: "LaptopApp",
    title: "Laptop App",
    path: "/account/laptop-app",
  },
  {
    screenName: "Training",
    screenClass: "Training",
    title: "Training",
    path: "/account/training",
  },
  {
    screenName: "Presentations",
    screenClass: "Presentations",
    title: "Presentations",
    path: "/presentations",
  },
  {
    screenName: "Presentations Creator",
    screenClass: "PresentationsCreator",
    title: "Presentations Creator",
    path: "/presentations-creator",
  },
  {
    screenName: "Add Presentation",
    screenClass: "AddPresentation",
    title: "Add Presentation",
    path: "/presentations/add",
  },
  {
    screenName: "Edit Presentation",
    screenClass: "EditPresentation",
    title: "Edit Presentation",
    path: "/presentations/edit/:id",
  },
  {
    screenName: "View Presentation",
    screenClass: "ViewPresentation",
    title: "View Presentation",
    path: "/presentations/view/:id",
  },
  {
    screenName: "Preview Presentation",
    screenClass: "ViewPresentation",
    title: "Preview Presentation",
    path: "/presentations/preview/:id",
  },
  {
    screenName: "Radisson For You",
    screenClass: "Radisson4u",
    title: "Radisson For You",
    path: "/radissonforyou",
  },
  { screenName: "News", screenClass: "News", title: "News", path: "/news" },
  {
    screenName: "News Single",
    screenClass: "NewsSingle",
    title: "News Single",
    path: "/news/view/:id",
  },
  {
    screenName: "Documents",
    screenClass: "Documents",
    title: "Documents",
    path: "/documents",
  },
  {
    screenName: "Document Single",
    screenClass: "DocumentSingle",
    title: "Document Single",
    path: "/documents/view/:id",
  },
  {
    screenName: "Videos",
    screenClass: "Videos",
    title: "Videos",
    path: "/videos",
  },
  {
    screenName: "Video Single",
    screenClass: "VideosSingle",
    title: "Video Single",
    path: "/videos/view/:id",
  },
  { screenName: "Polls", screenClass: "Polls", title: "Polls", path: "/polls" },
  {
    screenName: "Poll Single",
    screenClass: "PollSingle",
    title: "Poll Single",
    path: "/polls/view/:id",
  },
  { screenName: "Links", screenClass: "Links", title: "Links", path: "/links" },
  { screenName: "Forms", screenClass: "Forms", title: "Forms", path: "/forms" },
  {
    screenName: "Form Single",
    screenClass: "FormSingle",
    title: "Form Single",
    path: "/forms/view/:id",
  },
  {
    screenName: "Podcasts",
    screenClass: "Podcasts",
    title: "Podcasts",
    path: "/podcasts",
  },
  {
    screenName: "Podcast Single",
    screenClass: "PodcastSingle",
    title: "Podcast Single",
    path: "/podcasts/view/:id",
  },
  {
    screenName: "Quizzes",
    screenClass: "Quizzes",
    title: "Quizzes",
    path: "/quizzes",
  },
  {
    screenName: "Quiz Single",
    screenClass: "QuizSingle",
    title: "Quiz Single",
    path: "/quizzes/view/:id",
  },
  {
    screenName: "Events",
    screenClass: "Events",
    title: "Events",
    path: "/events",
  },
  {
    screenName: "Event Single",
    screenClass: "EventSingle",
    title: "Event Single",
    path: "/events/view/:id",
  },
  { screenName: "Blogs", screenClass: "Blogs", title: "Blogs", path: "/blogs" },
  {
    screenName: "Blog Single",
    screenClass: "BlogSingle",
    title: "Blog Single",
    path: "/blogs/:id",
  },
  {
    screenName: "Forums",
    screenClass: "ForumsBoard",
    title: "Forums",
    path: "/forums",
  },
  {
    screenName: "Forum Topics",
    screenClass: "ForumTopicList",
    title: "Forum Topics",
    path: "/forums/:tid",
  },
  {
    screenName: "Forum Topic Single",
    screenClass: "ForumTopicSingle",
    title: "Forum Topic Single",
    path: "/forums/:tid/:nid",
  },
  {
    screenName: "Galleries",
    screenClass: "Galleries",
    title: "Galleries",
    path: "/galleries",
  },
  {
    screenName: "Gallery Single",
    screenClass: "GallerySingle",
    title: "Gallery Single",
    path: "/galleries/view/:id",
  },
  {
    screenName: "Contacts",
    screenClass: "Contacts",
    title: "Contacts",
    path: "/contacts",
  },
  {
    screenName: "Contact Single",
    screenClass: "ContactSingle",
    title: "Contact Single",
    path: "/contacts/view/:id",
  },
  {
    screenName: "Company Directory",
    screenClass: "CompanyDirectory",
    title: "Company Directory",
    path: "/company_directory",
  },
  {
    screenName: "Company Directory Single",
    screenClass: "CompanyDirectorySingle",
    title: "Company Directory Single",
    path: "/company_directory/view/:id",
  },
  {
    screenName: "Training Single",
    screenClass: "CourseTrainingSingle",
    title: "Training Single",
    path: "/training/view/:id",
  },
  {
    screenName: "Search",
    screenClass: "SearchScreen",
    title: "Search",
    path: "/search",
  },
  {
    screenName: "Sales Rooms",
    screenClass: "SalesRooms",
    title: "Sales Rooms",
    path: "/sales-rooms",
  },
  {
    screenName: "Add Sales Room",
    screenClass: "AddSalesRoom",
    title: "Add Sales Room",
    path: "/sales-rooms/add",
  },
  {
    screenName: "Edit Sales Room",
    screenClass: "SalesRoomEdit",
    title: "Edit Sales Room",
    path: "/sales-rooms/edit/:id",
  },
  {
    screenName: "Sales Room Detail",
    screenClass: "SalesRoomDetail",
    title: "Sales Room Detail",
    path: "/sales-rooms/view/:id",
  },
  {
    screenName: "Buyer Room",
    screenClass: "BuyerRoom",
    title: "Room",
    path: "/room/:token",
  },
  {
    screenName: "My Tags",
    screenClass: "CompanyappTags",
    title: "My Tags",
    path: "/account/tags",
  },
  {
    screenName: "Contribute",
    screenClass: "Contribute",
    title: "Contribute",
    path: "/contribute",
  },
  {
    screenName: "Basic Auth",
    screenClass: "Login",
    title: "Basic Auth",
    path: "/basicAuth",
  },
  {
    screenName: "Auth",
    screenClass: "SSOAuth",
    title: "Login",
    path: "/login",
  },
  {
    screenName: "Auth Callback",
    screenClass: "AuthCallback",
    title: "Login Callback",
    path: "/login/callback",
  },
  {
    screenName: "Global Portfolio",
    screenClass: "GlobalPortfolio",
    title: "Global Portfolio",
    path: "/global-portfolio",
  },
  {
    screenName: "Hotel Profile",
    screenClass: "HotelProfile",
    title: "Hotel Profile",
    path: "/hotel-profile",
  },
];

export default function RoutesComponent(props) {
  const user = useSelector((state) => state).authReducer.user;
  const permissions = useSelector((state) => state).permissionsReducer
    .permissions;

  const dispatch = useDispatch();
  const setLocation = (data) =>
    dispatch({ type: "SET_LOCATION", payload: data });
  const toggleHeader = (data) =>
    dispatch({ type: "TOGGLE_HEADER", payload: data });

  const location = useLocation();

  useEffect(() => {
    onRouteChanged();
    // eslint-disable-next-line
  }, [location]);

  const onRouteChanged = () => {
    const _location = location.pathname.split("/");
    const segment = _location[1] || "";
    toggleHeader(true);

    if (segment.length > 0) {
      if (segment === "presentations") {
        if (_location[2]) {
          const loc = `${_location[2]}-presentations`;
          setLocation(loc);

          if (
            loc === "view-presentations" ||
            loc === "preview-presentations" ||
            loc === "thumbnail-presentations"
          ) {
            toggleHeader(false);
          }
        } else {
          setLocation(segment);
        }
      } else {
        setLocation(segment);

        // Buyer room portal renders chrome-less.
        if (segment === "room") {
          toggleHeader(false);
        }
      }
    } else {
      setLocation("home");
    }

    let currentPath = location.pathname;

    const matchedScreen = screenViews.find((screen) => {
      // Replace `:id` or dynamic segments with actual values in the current path
      const pathRegex = new RegExp(`^${screen.path.replace(/:\w+/g, "\\w+")}$`);
      return pathRegex.test(currentPath);
    });

    if (matchedScreen) {
      logScreenView(
        matchedScreen.screenName,
        matchedScreen.screenClass,
        matchedScreen.title,
      );
    }
  };

  const hasPermissions = Object.keys(permissions || {}).length > 0;

  if (user && user.current_user && permissionsEnabled && !hasPermissions) {
    return <div></div>; // or spinner
  }

  if (user.current_user) {
    // Internal data tool: the route is not registered for anyone else, so a
    // typed URL falls through to the catch-all rather than rendering a denial.
    const showHotelProfile = isCompanyappUser(user);

    if (client === "radisson") {
      return (
        <Routes>
          <Route path="/" element={<Navigate to="/presentations" replace />} />
          <Route path="/account" element={<Profile />} />
          <Route path="/account/notifications" element={<Notifications />} />
          <Route path="/account/add-in" element={<AddIn />} />
          <Route path="/account/laptop-app" element={<LaptopApp />} />
          <Route path="/account/training" element={<Training />} />
          {modeRoutes(PRESENTATIONS_ONLY)}
          <Route path="/presentations/add" element={<AddPresentation />} />
          <Route
            path="/presentations/edit/:id"
            element={<EditPresentation />}
          />
          <Route
            path="/presentations/view/:id"
            element={<ViewPresentation preview={false} />}
          />
          <Route
            path="/presentations/preview/:id"
            element={<ViewPresentation preview={true} />}
          />
          <Route path="/global-portfolio" element={<RHGMap />} />
          {showHotelProfile && (
            <Route path="/hotel-profile" element={<HotelProfile />} />
          )}

          <Route path="*" element={<Navigate to="/presentations" replace />} />
        </Routes>
      );
    }

    if (client === "revo-h") {
      return (
        <Routes>
          <Route
            path="/"
            element={
              <ModeRoute
                view={<Presentations />}
                creator={<PresentationsCreator />}
              />
            }
          />
          <Route path="/account" element={<Profile />} />
          <Route path="/account/notifications" element={<Notifications />} />
          <Route path="/account/add-in" element={<AddIn />} />
          <Route path="/account/laptop-app" element={<LaptopApp />} />
          <Route path="/account/training" element={<Training />} />
          {modeRoutes(PRESENTATIONS_ONLY)}
          <Route path="/presentations/add" element={<AddPresentation />} />
          <Route
            path="/presentations/edit/:id"
            element={<EditPresentation />}
          />
          <Route
            path="/presentations/view/:id"
            element={<ViewPresentation preview={false} />}
          />
          <Route
            path="/presentations/preview/:id"
            element={<ViewPresentation preview={true} />}
          />

          <Route path="*" element={<Navigate to="/presentations" replace />} />
        </Routes>
      );
    }

    if (client === "companyapp") {
      return (
        <Routes>
          <Route path="/" element={<CompanyappHome />} />
          <Route name="Account" path="/account" element={<Profile />} />
          <Route path="/account/notifications" element={<Notifications />} />
          <Route path="/account/add-in" element={<AddIn />} />
          <Route path="/account/laptop-app" element={<LaptopApp />} />
          <Route path="/account/training" element={<Training />} />
          <Route
            path="/account/push-notifications"
            element={<PushNotifications />}
          />
          {tagsEnabled && (
            <Route path="/account/tags" element={<CompanyappTags />} />
          )}

          {/* Mode-aware list routes + legacy "-creator" redirects */}
          {modeRoutes(COMPANYAPP_MODE_SEGMENTS)}

          {/* Presentations */}
          <Route path="/presentations/add" element={<AddPresentation />} />
          <Route
            path="/presentations/edit/:id"
            element={<EditPresentation />}
          />
          <Route
            path="/presentations/view/:id"
            element={<ViewPresentation preview={false} />}
          />
          <Route
            path="/presentations/preview/:id"
            element={<ViewPresentation preview={true} />}
          />

          {/* News */}
          <Route path="/news/view/:id" element={<NewsSingle />} />
          <Route path="/news/add" element={<AddNews />} />
          <Route path="/news/edit/:id" element={<NewsEdit />} />
          <Route
            path="/news/preview/:id"
            element={<NewsSingle preview={true} />}
          />

          {/* Documents */}
          <Route
            path="/documents/view/:id"
            element={<DocumentSingle preview={false} />}
          />
          <Route
            path="/documents/preview/:id"
            element={<DocumentSingle preview={true} />}
          />
          <Route path="/documents/add" element={<AddDocument />} />
          <Route path="/documents/edit/:id" element={<DocumentEdit />} />

          {/* Videos */}
          <Route path="/videos/view/:id" element={<VideosSingle />} />
          <Route path="/videos/add" element={<AddVideo />} />
          <Route path="/videos/edit/:id" element={<VideoEdit />} />
          <Route
            path="/videos/preview/:id"
            element={<VideosSingle preview={true} />}
          />

          {/* Polls */}
          <Route path="/polls/add" element={<AddPoll />} />
          <Route path="/polls/edit/:id" element={<PollEdit />} />
          <Route path="/polls/view/:id" element={<PollSingle />} />
          <Route
            path="/polls/preview/:id"
            element={<PollSingle preview={true} />}
          />

          {/* Links */}
          <Route path="/links/add" element={<AddLink />} />
          <Route path="/links/edit/:id" element={<LinkEdit />} />

          {/* Forms */}
          <Route path="/forms/add" element={<AddForm />} />
          <Route path="/forms/edit/:id" element={<FormEdit />} />
          <Route path="/forms/view/:id" element={<FormSingle />} />
          <Route
            path="/forms/preview/:id"
            element={<FormSingle preview={true} />}
          />

          {/* Podcasts */}
          <Route path="/podcasts/view/:id" element={<PodcastSingle />} />
          <Route
            path="/podcasts/preview/:id"
            element={<PodcastSingle preview={true} />}
          />
          <Route path="/podcasts/add" element={<AddPodcast />} />
          <Route path="/podcasts/edit/:id" element={<PodcastEdit />} />

          {/* Quizzes */}
          <Route path="/quizzes/add" element={<AddQuiz />} />
          <Route path="/quizzes/edit/:id" element={<QuizEdit />} />
          <Route
            path="/quizzes/preview/:id"
            element={<QuizSingle preview={true} />}
          />
          <Route path="/quizzes/view/:id" element={<QuizSingle />} />

          {/* Events */}
          <Route path="/events/view/:id" element={<EventSingle />} />
          <Route
            path="/events/preview/:id"
            element={<EventSingle preview={true} />}
          />
          <Route path="/events/add" element={<AddEvent />} />
          <Route path="/events/edit/:id" element={<EventEdit />} />

          {/* Blogs / Forums (no creator mode) */}
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:id" element={<BlogSingle />} />
          <Route path="/forums" element={<ForumsBoard />} />
          <Route path="/forums/:tid" element={<ForumTopicList />} />
          <Route path="/forums/:tid/:nid" element={<ForumTopicSingle />} />

          {/* Galleries */}
          <Route path="/galleries/view/:id" element={<GallerySingle />} />
          <Route
            path="/galleries/preview/:id"
            element={<GallerySingle preview={true} />}
          />
          <Route path="/galleries/add" element={<AddGallery />} />
          <Route path="/galleries/edit/:id" element={<GalleryEdit />} />

          {/* Contacts (no creator mode) */}
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/contacts/view/:id" element={<ContactSingle />} />

          {/* Training */}
          <Route path="/training/view/:id" element={<CourseTrainingSingle />} />
          <Route
            path="/training/preview/:id"
            element={<CourseTrainingSingle preview={true} />}
          />
          <Route path="/training/add" element={<AddTraining />} />
          <Route path="/training/edit/:id" element={<TrainingEdit />} />

          <Route path="/contribute" element={<ContributeCA />} />

          {/* Company directory */}
          <Route
            path="/company_directory/add"
            element={<AddCompanyDirectory />}
          />
          <Route
            path="/company_directory/view/:id"
            element={<CompanyDirectorySingle />}
          />
          <Route
            path="/company_directory/preview/:id"
            element={<CompanyDirectorySingle preview={true} />}
          />
          <Route
            path="/company_directory/edit/:id"
            element={<CompanyDirectoryEdit />}
          />

          <Route path="/bookmarks" element={<Bookmarks />} />
          <Route path="/taxonomies" element={<Taxonomies />} />
          <Route path="/taxonomies/:id" element={<TaxonomySingle />} />
          <Route path="/taxonomies/term/:vid/:tid" element={<TermSingle />} />
          <Route
            path="/taxonomies/term/:vid/add"
            element={<TermSingle add={true} />}
          />
          <Route path="/search" element={<SearchScreen />} />
          {salesRoomsEnabled && (
            <Route path="/sales-rooms" element={<SalesRooms />} />
          )}
          {salesRoomsEnabled && (
            <Route path="/sales-rooms/add" element={<AddSalesRoom />} />
          )}
          {salesRoomsEnabled && (
            <Route path="/sales-rooms/edit/:id" element={<SalesRoomEdit />} />
          )}
          {salesRoomsEnabled && (
            <Route path="/sales-rooms/view/:id" element={<SalesRoomDetail />} />
          )}
          {salesRoomsEnabled && (
            <Route path="/room/:token" element={<BuyerRoom />} />
          )}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      );
    }

    if (client === "equans") {
      return (
        <Routes>
          <Route path="/" element={<Navigate to="/news" replace />} />
          <Route path="/account" element={<Profile />} />
          <Route path="/news" element={<NewsNode />} />
          <Route path="/news/view/:id" element={<NewsSingleNode />} />
          <Route path="/documents" element={<DocumentsNode />} />
          <Route path="/documents/view/:id" element={<DocumentSingleNode />} />
          <Route path="/videos" element={<VideosNode />} />
          <Route path="/videos/view/:id" element={<VideoSingleNode />} />
          <Route path="/polls/view/:id" element={<PollSingle />} />
          <Route path="/links" element={<LinksNode />} />
          <Route path="/forms/view/:id" element={<FormSingle />} />
          <Route path="/podcasts" element={<PodcastsNode />} />
          <Route path="/podcasts/view/:id" element={<PodcastSingleNode />} />
          <Route path="/quizzes" element={<Quizzes />} />
          <Route path="/quizzes/view/:id" element={<QuizSingle />} />
          <Route path="/training" element={<CourseTrainingNode />} />
          <Route
            path="/training/view/:id"
            element={<CourseTrainingSingleNode />}
          />
          <Route path="/events" element={<EventsNode />} />
          <Route path="/events/view/:id" element={<EventSingleNode />} />
          <Route path="/search" element={<SearchScreen />} />
          <Route path="/my-hr-services" element={<Fiori />} />
          <Route path="*" element={<Navigate to="/" replace />} />
          <Route path="/contribute" element={<Contribute />} />
          <Route path="*" element={<Navigate to="/news" replace />} />
        </Routes>
      );
    }
  } else {
    if (client === "radisson") {
      return (
        <Routes>
          <Route
            path="/presentations/view/:id"
            element={<ViewPresentation preview={false} />}
          />
          <Route path="/basicAuth" element={<Login />} />
          <Route path="/login" element={<SSOAuth />} />
          <Route path="/login/callback" element={<AuthCallback />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      );
    }

    if (client === "revo-h") {
      return (
        <Routes>
          <Route
            path="/presentations/view/:id"
            element={<ViewPresentation preview={false} />}
          />
          <Route path="/basicAuth" element={<Login />} />
          <Route path="/login" element={<Oauth />} />
          <Route path="/login/callback" element={<OAuthCallback />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      );
    }

    if (client === "companyapp") {
      return (
        <Routes>
          <Route path="/" element={<CompanyappHome isPublic={true} />} />
          <Route path="/news/view/:id" element={<NewsSingle />} />
          <Route path="/blogs/:id" element={<BlogSingle />} />
          <Route path="/events/view/:id" element={<EventSingle />} />
          <Route path="/documents/view/:id" element={<DocumentSingle />} />
          <Route path="/videos/view/:id" element={<VideosSingle />} />
          <Route path="/podcasts/view/:id" element={<PodcastSingle />} />
          <Route path="/galleries/view/:id" element={<GallerySingle />} />
          <Route path="/forms/view/:id" element={<FormSingle />} />
          <Route path="/polls/view/:id" element={<PollSingle />} />
          <Route
            path="/presentations/view/:id"
            element={<ViewPresentation preview={false} />}
          />
          <Route path="/room/:token" element={<BuyerRoom />} />
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      );
    }

    if (client === "equans") {
      return (
        <Routes>
          <Route path="/basicAuth" element={<Login />} />
          <Route path="/login" element={<Oauth />} />
          <Route path="/login/callback" element={<OAuthCallback />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      );
    }
  }
}
